import React from "react";

const STAGES = [
  "Reported",
  "Survey Pending",
  "Survey Completed",
  "Workshop",
  "Documents Pending",
  "Ready For Submission",
  "Submitted",
  "Approved",
  "Closed",
];

const TimelineSection = ({ insurance }) => {
  const status = insurance.status;
  const isRejected = status === "Rejected";

  const referenceStatus = isRejected ? "Submitted" : status;
  const currentIndex = STAGES.indexOf(referenceStatus);

  const visibleStages = isRejected
    ? STAGES.slice(0, currentIndex + 1)
    : STAGES;

  const progressPct = isRejected
    ? 100
    : (currentIndex / (STAGES.length - 1)) * 100;

  return (
    <div className="section-card">
      <div className="section-title">Claim Progress</div>

      <div className="timeline-progress">
        <div className="timeline-progress-bar">
          <div
            className={`timeline-progress-fill ${isRejected ? "is-rejected" : ""}`}
            style={{ width: `${progressPct}%` }}
          />
        </div>
        <span className="timeline-progress-label">
          {isRejected
            ? "Rejected after submission"
            : `Step ${currentIndex + 1} of ${STAGES.length}`}
        </span>
      </div>

      <div className="insurance-timeline">
        {visibleStages.map((stage, index) => {
          const state =
            isRejected && index === visibleStages.length - 1
              ? "is-done"
              : index < currentIndex
              ? "is-done"
              : index === currentIndex
              ? "is-active"
              : "is-upcoming";

          return (
            <div className={`timeline-item ${state}`} key={stage}>
              <div className="timeline-marker">
                {state === "is-done" ? "✓" : index + 1}
              </div>

              <div className="timeline-content">
                <div className={`timeline-title ${state}`}>{stage}</div>
                {state === "is-active" && (
                  <div className="timeline-date">Current Status</div>
                )}
              </div>
            </div>
          );
        })}

        {isRejected && (
          <div className="timeline-item is-rejected">
            <div className="timeline-marker">✕</div>
            <div className="timeline-content">
              <div className="timeline-title is-rejected">Rejected</div>
              <div className="timeline-date is-rejected">Claim Rejected</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TimelineSection;